export const ERROR_NOTIFICATION = 'ERROR';
export const SUCCESS_NOTIFICATION = 'SUCCESS';

export type NotificationType = typeof ERROR_NOTIFICATION | typeof SUCCESS_NOTIFICATION;
